import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";

const Section = styled.section`
  padding: 96px 0;
  background: var(--nd-surface);
`;

const SectionLabel = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin: 0 0 16px;
`;

const SectionTitle = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 36px;
  font-weight: 500;
  color: var(--nd-text-display);
  letter-spacing: -0.02em;
  margin: 0 0 48px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;

const Card = styled.div`
  background: var(--nd-black);
  border: 1px solid var(--nd-border);
  border-radius: 12px;
  padding: 28px;
`;

const Name = styled.h3`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: var(--nd-text-display);
  margin: 0 0 8px;
`;

const Desc = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0 0 12px;
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const Chip = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  border: 1px solid var(--nd-border-visible);
  border-radius: 4px;
  padding: 3px 8px;
`;

const ITEMS = [
  {
    name: "CI/CD",
    desc: "Pipelines that don't break on Friday afternoon. GitOps where it makes sense.",
    chips: ["GitHub Actions", "GitLab CI", "ArgoCD", "Flux"],
  },
  {
    name: "Kubernetes",
    desc: "EKS, GKE, AKS, self-managed. Karpenter, autoscaling, cost-optimised node pools.",
    chips: ["EKS", "GKE", "Helm", "Karpenter", "Istio"],
  },
  {
    name: "Infrastructure as Code",
    desc: "Reusable modules with policy guardrails. No more snowflake environments.",
    chips: ["Terraform", "Pulumi", "OPA", "Checkov"],
  },
  {
    name: "Observability",
    desc: "Metrics, traces, logs, SLOs. We tune the noise out so on-call doesn't burn out.",
    chips: ["OpenTelemetry", "Prometheus", "Grafana", "Datadog", "Loki"],
  },
  {
    name: "Security",
    desc: "Secrets out of plaintext, IAM least-privilege, container scanning, pod security.",
    chips: ["Vault", "SOPS", "Trivy", "OPA Gatekeeper"],
  },
  {
    name: "FinOps",
    desc: "Rightsizing, Savings Plans, Spot consolidation. Receipts you can show finance.",
    chips: ["Karpenter", "Spot", "Savings Plans", "Cost Explorer"],
  },
];

const WhatWeTouch = () => (
  <Section>
    <Container>
      <SectionLabel>What we touch</SectionLabel>
      <SectionTitle>Six areas. Deep, not wide.</SectionTitle>
      <Grid>
        {ITEMS.map((it) => (
          <Card key={it.name}>
            <Name>{it.name}</Name>
            <Desc>{it.desc}</Desc>
            <Chips>
              {it.chips.map((c) => (
                <Chip key={c}>{c}</Chip>
              ))}
            </Chips>
          </Card>
        ))}
      </Grid>
    </Container>
  </Section>
);
export default WhatWeTouch;
